<template>
  <div>
    <b-row class="text-center my-5">
      <b-col>
        <h2><span class="dbb-red">WIN Digital Brain Bank</span></h2>
        <h4><span class="dbb-grey">Neuroimaging data in post-mortem brains collected by University of Oxford researchers & collaborators 
</span></h4>
      </b-col>
    </b-row>
    <b-row class="text-center mt-5">
      
      <!-- anatomist -->
      <b-col md="4" class="mx-auto d-flex justify-content-center">
        <b-card
          title="Digital Anatomist"
          img-src="@/assets/DA.png"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem"
          class="mb-2 border-0"
          bg-variant=""
        >
          <b-card-text class="h100">
            Datasets for neuroanatomical investigations
          </b-card-text>

          <b-button size="lg" class="btn-red" href="#/datasets/anatomist" variant="primary">View Datasets</b-button>
        </b-card> 
      </b-col>

      <!-- zoo -->
      <b-col md="4" class="mx-auto d-flex justify-content-center">
        <b-card
          title="Digital Brain Zoo"
          img-src="@/assets/DZ.png"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem"
          class="mb-2 border-0"
          bg-variant=""
        >
          <b-card-text class="h100">
           Datasets for comparative neuroanatomy 
          </b-card-text>

          <b-button size="lg" class="btn-red" href="#/datasets/zoo" variant="primary">View Datasets</b-button>
        </b-card>
      </b-col>


      <!-- pathologist -->
      <b-col md="4" class="mx-auto d-flex justify-content-center">
        <b-card
          title="Digital Pathologist"
          img-src="@/assets/DP.png"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem"
          class="mb-2 border-0"
          bg-variant=""
        >
          <b-card-text class="h100">
           Datasets for neuropathology investigations 
          </b-card-text>

          <b-button size="lg" class="btn-red" href="#/datasets/pathologist" >View Datasets</b-button>
        </b-card>
      </b-col>
    </b-row>
    
    
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>

<style scoped>
.h100 {
  min-height: 100px;
}
.dbb-red {
  color: #8b2a34;
}

.dbb-grey {
  color: 	#A9A9A9;
}

.btn-red {
  background-color: #8b2a34;
  border-color: #8b2a34;
}
</style>
